<template>
  <img class="off" src="/public/icons/user-off.svg" alt="" />
  <img class="on" src="/public/icons/user-on.svg" alt="" />
</template>

<script>
export default {
  name: 'IconAddStaff',
};
</script>

<style scoped>
.icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  fill: inherit;
  flex-shrink: 0;
}
</style>
